<footer>
  <div class="footer-container">
    <div
      class="d-flex flex-column flex-sm-row gap-size-50 justify-content-center align-items-start align-items-lg-center"
    >
      <!-- Desktop Footer -->
      <div
        class="d-none d-sm-flex flex-column flex-lg-row flex-wrap gap-size-25 justify-content-between"
      >
        <a
          target="_blank"
          href="/terms-of-use"
          class="d-flex flex-row align-items-center gap-1"
        >
          <img src="assets/icons/file-check.svg" alt="file-check" />
          <span class="footer-text">Terms of Use</span>
        </a>
        <a
          target="_blank"
          href="/privacy-policy"
          class="d-flex flex-row align-items-center gap-1"
        >
          <img src="assets/icons/shield-check.svg" alt="shield-check" />
          <span class="footer-text">Privacy Policy</span>
        </a>
        <a
          target="_blank"
          href="/about-us"
          class="d-flex flex-row align-items-center gap-1"
        >
          <img src="assets/icons/info-triangle.svg" alt="info-triangle" />
          <span class="footer-text">About Us</span>
        </a>
      </div>

      <a href="/" class="footer-logo">
        <img src="assets/logos/loansWhiteLogo.png" alt="loansLogo" />
      </a>

      <div
        class="d-none d-sm-flex flex-column flex-lg-row flex-wrap gap-size-25 justify-content-between"
      >
        <button
          class="footer-tooltip-wrapper"
          [class.show-tooltip]="isTooltipVisible"
        >
          <div
            class="d-flex flex-row align-items-center gap-1 footer-tooltip-trigger"
            (click)="toggleTooltip()"
          >
            <img src="assets/icons/speakerphone.svg" alt="speakerphone" />
            <span class="footer-text">Advertising Disclosure</span>
          </div>

          <div class="footer-tooltip">
            <span>
              The offers that appear on this site are from insurance companies from which Finance Razor and its partners receive compensation. This compensation may influence the selection, appearance, and order of insurance quotes listed on our platform. However, this compensation also enables Finance Razor to provide our comparison services to you at no charge. The insurance offers shown do not include all insurance companies or all available insurance products and coverage options in the market.
            </span>
          </div>
        </button>
        <a
          target="_blank"
          href="/cookie-policy"
          class="d-flex flex-row align-items-center gap-1"
        >
          <img src="assets/icons/cookie.svg" alt="cookie" />
          <span class="footer-text">Cookie Policy</span>
        </a>
        <a
          target="_blank"
          href="/contact-us"
          class="d-flex flex-row align-items-center gap-1"
        >
          <img src="assets/icons/contact.svg" alt="contact" />
          <span class="footer-text">Contact</span>
        </a>
      </div>

      <!-- Mobile Footer -->
      <div
        class="d-flex flex-row d-sm-none justify-content-center align-items-start gap-size-50"
      >
        <div class="d-flex flex-column gap-size-25">
          <a
            href="/terms-of-use"
            class="d-flex flex-row align-items-start gap-1"
          >
            <img src="assets/icons/file-check.svg" alt="file-check" />
            <span class="footer-text">Terms of Use</span>
          </a>
          <a
            href="/privacy-policy"
            class="d-flex flex-row align-items-start gap-1"
          >
            <img src="assets/icons/shield-check.svg" alt="shield-check" />
            <span class="footer-text">Privacy Policy</span>
          </a>
          <a href="/about-us" class="d-flex flex-row align-items-start gap-1">
            <img src="assets/icons/info-triangle.svg" alt="info-triangle" />
            <span class="footer-text">About Us</span>
          </a>
        </div>
        <div class="d-flex flex-column gap-size-25">
          <button
            class="footer-tooltip-wrapper"
            [class.show-tooltip]="isTooltipVisible"
          >
            <div
              class="d-flex flex-row align-items-center gap-1 footer-tooltip-trigger"
              (click)="toggleTooltip()"
            >
              <img src="assets/icons/speakerphone.svg" alt="speakerphone" />
              <span class="footer-text">Advertising Disclosure</span>
            </div>

            <div class="footer-tooltip">
              <span>
                The offers that appear are from companies which
                Loansgenerator.com and its partners receive compensation. This
                compensation may influence the selection, appearance, and order
                of appearance of the offers listed below. However, this
                compensation also facilitates the provision by
                Loansgenerator.com of certain services to you at no charge. The
                offers shown below do not include all financial services
                companies or all of their available product and service
                offerings.
              </span>
            </div>
          </button>
          <a
            href="/cookie-policy"
            class="d-flex flex-row align-items-start gap-1"
          >
            <img src="assets/icons/cookie.svg" alt="cookie" />
            <span class="footer-text">Cookie Policy</span>
          </a>
          <a href="/contact-us" class="d-flex flex-row align-items-start gap-1">
            <img src="assets/icons/contact.svg" alt="contact" />
            <span class="footer-text">Contact</span>
          </a>
        </div>
      </div>
    </div>

    <p class="footer-copyright">
      Copyright © 2009-{{findCurrentYear()}} Pastime-Live Inc. All Rights Reserved.
    <br>
      By using our content, products & services you agree to our Terms of Use and Privacy Policy.
    </p>   
  </div>
</footer>
